module.exports = __webpack_public_path__ + "static/img/cont35 (9).d5dcaeb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont35 (9).jpg
// module id = N62g
// module chunks = 0